import { Component } from '@angular/core';
import { Select } from '@ngxs/store';
import { MatterAccountingSelectors } from '@state/matter/accounting/accounting.selectors';
import { Observable } from 'rxjs';
import { UntilDestroy } from '@ngneat/until-destroy';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { MatterStatementofAccountSelectors } from '@state/matter/statementOfAccounts/statementOfAccounts.selectors';
import { StatementOfAccountTotals } from '@services/financialTotals/financial-totals.service';
import { SolunoItem } from '../accounting.models';
@UntilDestroy()
@Component({
	selector: 'app-soluno',
	templateUrl: './soluno.component.html',
	standalone: false,
})
export class SolunoComponent {
	@Select(MatterAccountingSelectors.getSolunoNonZeroNonHstItems)
	solunoNonHstItems$: Observable<SolunoItem[]>;
	@Select(MatterAccountingSelectors.getSolunoNonZeroHstItems)
	solunoHstItems$: Observable<SolunoItem[]>;
	@Select(MatterAccountingSelectors.getSolunoNonZeroConvenyancingFeeItems)
	solunoConvenyancingFeeItems$: Observable<SolunoItem[]>;
	@Select(MatterStatementofAccountSelectors.statementOfAccountsTotals)
	totals$: Observable<StatementOfAccountTotals>;

	@Select(SelectedMatter.matterHST) hst$: Observable<number>;
}
